import React from 'react';
import { connectWithStore } from '@react/Common/connectWithStore';
import { getUserPermissionsState } from '@redux/ducks/userPermissions/userPermissions';
import { AppList } from './ListApps';
import { SearchAppList } from './SearchAppList';

const AppListPageComponent = ({ onCancel, submitEnabled }) => (
  <div className="content content-panel flex-one flex-box-column">
    <div className="content-title-box without-background">
      <div className="flex-auto">
        <h3 className="content-heading">{t('label.app-access')}</h3>
      </div>
    </div>

    <div className="content-inner flex-one flex-box-column">
      <div className="content panel-content flex-auto">
        <SearchAppList />
      </div>

      <div className="content panel-content flex-one">
        <AppList />
      </div>

      <div className="content panel-content flex-auto">
        <div className="panel-footer flex-auto">
          <div className="flex-box-row">
            <a onClick={onCancel} className="btn flex-one">
              {t('action.back')}
            </a>
            <button disabled={!submitEnabled} onClick={onCancel} className="btn btn-main flex-one">
              {t('action.apply')}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const mapStateToProps = state => {
  const { user, canApplyAppPermissions, canApplyUserPermissions } = getUserPermissionsState(state);
  const canApply = canApplyUserPermissions || canApplyAppPermissions;

  return { submitEnabled: user?.id ? canApply : true };
};

export const AppListPage = connectWithStore(mapStateToProps)(AppListPageComponent);
